<template>
  <div id="editProfileContainer">
    <profile/>
  </div>
</template>

<script>
import Profile from './Profile'
export default {
  components: {
    Profile
  }
}
</script>
